<template>
  <div>
    <div class="page-title">开具发票</div>
    <page-tab
      :tabs="tabs"
      :nowTab="nowTab"
      :paramsLabel="'index'"
    ></page-tab>
    <page-search
      :layout="['code', 'name', 'date', 'export']"
      @search="search"
      @exportTable="exportTable"
    ></page-search>
    <pageTable
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :pageSize="pageSize"
      :pageIndex="page"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>

<script>
import Vue from 'vue'
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import pageTab from '@/components/pageCom/pageTab.vue'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import { invoiceUkeyList, getNeedAddCount } from '@/api/invoice'
import { downFile } from '@/utils/file'
export default {
  name: 'ukeyInvoice',
  components: {
    pageTab,
    pageSearch,
    pageTable
  },
  mixins: [pageTableMixin],
  data() {
    return {
      tabs: [
        { text: 'UKEY', num: '', linkName: 'ukeyInvoice' },
        { text: '手续费', num: '', linkName: 'feeInvoice' }
      ],
      col: [
        { field: 'infoNo', title: '序号', width: 50, titleAlign: 'left', columnAlign: 'left',
          formatter: (rowData, index) => {
            const num = (this.page - 1) * this.pageSize + (index + 1)
            return num
          }
        },
        { field: 'operate', title: '操作', width: 80, titleAlign: 'left', columnAlign: 'left', componentName: 'ukeyInvoiceOpe' },
        { field: 'order_id', title: '订单编号', width: 230, titleAlign: 'left', columnAlign: 'left' },
        { field: 'create_time', title: '下单日期', width: 140, titleAlign: 'left', columnAlign: 'left' },
        { field: 'buy_status', title: '状态', width: 80, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            if (rowData['buy_status'] === '0') {
              return '<span>待付款</span>'
            } else if (rowData['buy_status'] === '1') {
              return '<span>已付款</span>'
            } else {
              return ''
            }
          }
        },
        { field: 'buy_type', title: '支付方式', width: 80, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            if (rowData['buy_type'] === '0') {
              return '<span>支付宝</span>'
            } else if (rowData['buy_type'] === '1') {
              return '<span>微信</span>'
            } else if (rowData['buy_type'] === '2') {
              return '<span>线下付款</span>'
            } else {
              return ''
            }
          }
        },
        { field: 'cust_no', title: '企业编码', width: 80, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cust_name', title: '下单用户', width: 230, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
        { field: 'order_content', title: '服务内容', width: 230, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'order_money', title: '订单金额', width: 140, titleAlign: 'left', columnAlign: 'left' },
        // { field: 'type', title: '发票类型', width: 140, titleAlign: 'left', columnAlign: 'left' },
        { field: 'name', title: '名称', width: 230, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'address', title: '地址', width: 230, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
        { field: 'tel', title: '电话', width: 140, titleAlign: 'left', columnAlign: 'left' },
        { field: 'tax_number', title: '税号', width: 140, titleAlign: 'left', columnAlign: 'left' },
        { field: 'bank', title: '开户行', width: 230, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'account_number', title: '账号', width: 140, titleAlign: 'left', columnAlign: 'left' }
      ],
      searchParams: ''
    }
  },
  computed: {
    nowTab() {
      return this.$route.name
    }
  },
  watch: {
    nowTab() {
      this.getData()
    }
  },
  methods: {
    initPage() {
      this.searchParams = ''
    },
    getNeedCount() {
      getNeedAddCount({
        tab_type: '1',
        cust_no: this.searchParams.code || '',
        cust_name: this.searchParams.name || '',
        create_time_start: this.searchParams.date ? this.searchParams.date[0] : '',
        create_time_end: this.searchParams.date ? this.searchParams.date[1] : ''
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          this.tabs[0].num = '待开' + result.ukey
          this.tabs[1].num = '待开' + result.service
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    },
    // 获取表格
    getData() {
      this.tableLoading = true
      this.getNeedCount()
      invoiceUkeyList({
        cust_no: this.searchParams.code || '',
        cust_name: this.searchParams.name || '',
        create_time_start: this.searchParams.date ? this.searchParams.date[0] : '',
        create_time_end: this.searchParams.date ? this.searchParams.date[1] : '',
        per_page: this.pageSize,
        page: this.page
      }).then(res => {
        this.tableLoading = false
        const { code, result } = res
        if (code === 0) {
          this.tableData = result.data
          this.total = result.count
        } else if (res.code !== 10008) {
          this.tableData = []
          this.total = 0
          this.$Message.info(res.msg)
        }
      })
    },
    // 搜索
    search(query) {
      this.searchParams = query
      this.initTable()
      this.getData()
    },
    exportTable() {
      const url = process.env.VUE_APP_BASE_API + '/invoice/export_excel'
      const params = {
        table_type: '1',
        cust_no: this.searchParams.code || '',
        cust_name: this.searchParams.name || '',
        create_time_start: this.searchParams.date ? this.searchParams.date[0] : '',
        create_time_end: this.searchParams.date ? this.searchParams.date[1] : '',
        per_page: this.pageSize,
        page: this.page
      }
      downFile(url, params)
    }
  }
}
// 自定义列组件
Vue.component('ukeyInvoiceOpe', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    makeout() {
      this.$router.push({
        name: 'makeout', params: { type: 'ukey', id: this.rowData.id }
      })
    },
    detail(rowData) {
      this.$router.push({
        name: 'invoiceDetail', params: { type: 'ukey', id: this.rowData.id }
      })
    }
  },
  render: function(h) {
    if (this.rowData.bill_info && this.rowData.bill_info === '0') {
      return h('span', {
        class: 'no-invoice'
      }, '____')
    }
    if (this.rowData.has_bill === '0') {
      // 开发票
      return h('div', {
        class: 'link-btn',
        on: {
          click: this.makeout
        }
      }, '开发票')
    } else {
      // 查看发票
      return h('div', {
        class: 'link-btn link-btn-green',
        on: {
          click: this.detail
        }
      }, '查看发票')
    }
  }
})
</script>
